<script>
import options from "./PromotionCollections.options";
export default options;
</script>

<template>
    <article class="nti-promotion" v-if="!hasPromotionCardData">
        <section class="nti-promotion__container">
            <h2 class="nti-promotion__title">{{ bestsellersTitle }}</h2>
            <div class="nti-promotion__card-container">
                <template v-for="(card, index) in bestsellersList" :key="index">
                    <BestSellerCard :card="card" :label="label"/>
                </template>
            </div>
        </section>

        <section class="nti-promotion__container">
            <h2 class="nti-promotion__title">{{ campaignTitle }}</h2>
            <div class="nti-promotion__card-container">
                <template v-for="(card, index) in campaignsList" :key="index">
                    <CampaignCard :card="card" :label="label"/>
                </template>
            </div>
        </section>
    </article>
</template>